import { inject, Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { breakpoints } from '../models/breakpoints';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BreakpointService {
    private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);

    public activeBreakpoints: BehaviorSubject<BreakpointState | null> = new BehaviorSubject<BreakpointState | null>(null);
    public isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isTablet: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isTabletPlus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isLaptop: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isLaptopPlus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isDesktop: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isDesktopPlus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isTv: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public init(): void {
        this.breakpointObserver.observe([
            breakpoints.mobile,
            breakpoints.tablet,
            breakpoints.tabletPlus,
            breakpoints.laptop,
            breakpoints.laptopPlus,
            breakpoints.desktop,
            breakpoints.desktopPlus,
            breakpoints.tv
        ]).subscribe((state: BreakpointState): void => {
            this.set(state);
        });
    }

    public set(state: BreakpointState): void {
        this.isMobile.next(state.breakpoints[breakpoints.mobile]);
        this.isTablet.next(state.breakpoints[breakpoints.tablet]);
        this.isTabletPlus.next(state.breakpoints[breakpoints.tabletPlus]);
        this.isLaptop.next(state.breakpoints[breakpoints.laptop]);
        this.isLaptopPlus.next(state.breakpoints[breakpoints.laptopPlus]);
        this.isDesktop.next(state.breakpoints[breakpoints.desktop]);
        this.isDesktopPlus.next(state.breakpoints[breakpoints.desktopPlus]);
        this.isTv.next(state.breakpoints[breakpoints.tv]);
        this.activeBreakpoints.next(state);
    }
}
